import {
  CarrierSpecificClaimInfoSchema,
  ShippingClaimPhotoSchema,
  ShippingClaimReason,
} from "@redotech/redo-model/shipping-claims/shipping-claim";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const submitShippingClaim = {
  name: "submitShippingClaim" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    trackingNumber: z.string().nullish(),
    reason: createEnum(ShippingClaimReason),
    photos: z.array(ShippingClaimPhotoSchema).nullish(),
    notes: z.string().optional(),
    carrierSpecificInfo: CarrierSpecificClaimInfoSchema.nullish(),
  }),
  output: z.object({
    success: z.boolean(),
    claimId: z.string(),
    message: z.string(),
  }),
};
